import { render, staticRenderFns } from "./judgeac.vue?vue&type=template&id=53ec5b9d&scoped=true&lang=html&"
import script from "./judgeac.vue?vue&type=script&lang=js&"
export * from "./judgeac.vue?vue&type=script&lang=js&"
import style0 from "./judgeac.vue?vue&type=style&index=0&id=53ec5b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ec5b9d",
  null
  
)

export default component.exports